import { render, staticRenderFns } from "./DetalleEvento.vue?vue&type=template&id=131a2c16&scoped=true"
import script from "./DetalleEvento.vue?vue&type=script&lang=js"
export * from "./DetalleEvento.vue?vue&type=script&lang=js"
import style0 from "./DetalleEvento.vue?vue&type=style&index=0&id=131a2c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131a2c16",
  null
  
)

export default component.exports